import React, { useState } from "react";
import MetaTags from "react-meta-tags";
import { arit, mua } from "../config/api";

import axios from "axios";
import picpresent1 from "../assets/procedurepresent/1.jpg";
import picpresent2 from "../assets/procedurepresent/2.jpg";
import picpresent3 from "../assets/procedurepresent/3.jpg";
import picpresent4 from "../assets/procedurepresent/4.jpg";
import picpresent5 from "../assets/procedurepresent/5.jpg";
import picpresent6 from "../assets/procedurepresent/6.jpg";
import picpresent7 from "../assets/procedurepresent/7.jpg";
import picpresent8 from "../assets/procedurepresent/8.jpg";
import picpresent9 from "../assets/procedurepresent/9.jpg";
import picpresent10 from "../assets/procedurepresent/10.jpg";
import picpresent11 from "../assets/procedurepresent/11.jpg";
import picpresent12 from "../assets/procedurepresent/12.jpg";
import { MDBInput } from "mdbreact";
import Insertpresent1 from "./formpresent/insertpresent1";
import Swal from "sweetalert2";
import { useEffect } from "react";

function CheckPresentNew() {   
  useEffect(() => {
    localStorage.clear();
  }, []);
  const [Ctizen, setCtizen] = useState("1779800052391");
  const CheckPDPA = ()=>{
      axios
          .get(
            arit + "/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
              Ctizen +
              "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
          )
          .then((ress) => {
            if (ress.data.length === 0) {
              window.location.href =
                arit + "/ap/account/?nu=pdpaAgree&code=" +
                btoa(Ctizen) +
                "&status=" +
                btoa(3) +
                "&url=" +
                btoa(
                  window.location.origin + (process.env.REACT_APP_BASENAME || "") + "/Insertpresent1"
                );
            } else {
              
            }
          });
  }
  const SubmitLogin = () => {
    axios
      .get(
        mua + "/admissionnew2022/showlistregister?id=" +
          Ctizen
      )
      .then((res) => {
        if (res.data.data.data.length !== 0) {
          console.log(res.data.data.data[0]);
          const data = res.data.data.data[0];
          localStorage.setItem("REGISTER_ID", data.REGISTER_ID);
          if(data.Major1_MAJOR_ID === "9903"){

          }
        }
      });
  };
  return (
    <div className="container-md">
      <div className="card mx-2 my-3 p-3">
        <strong>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</strong>
        <div className="d-flex justify-content-center">
          <div className="col-sm-8 col-12">
            <MDBInput
              label="รหัสเลขบัตรประชาชน/เลข Passport"
              onChange={(e) => {
                setCtizen(e.target.value);
              }}
              outline
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <div className="col-sm-8 col-12 ">
            <div
              className={
                Ctizen.length < 13
                  ? "btn btn-info w-100 m-0 disabled"
                  : "btn btn-info w-100 m-0"
              }
              onClick={SubmitLogin}
            >
              กรอกข้อมูลรายงานตัว
            </div>
          </div>
        </div>
      </div>
      <div className="card mx-2 my-3 p-3">
       
        <div className="text-center mt-2 mb-2">
          <iframe
            width={"100%"}
            height={"100%"}
            style={{ aspectRatio: "4/3", maxHeight: "280px" }}
            src="https://www.youtube.com/embed/nJeV88-XXPs"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowfullscreen
          ></iframe>
        </div>
      </div>
      <div className="card mx-2 my-3 p-3">
        <div className="bg-info p-3 rounded text-white ">
          ขั้นตอนการรายงานตัว
        </div>
        <img alt="" src={picpresent1} />
        <img alt="" src={picpresent2} />
        <img alt="" src={picpresent3} />
        <img alt="" src={picpresent4} />
        <img alt="" src={picpresent5} />
        <img alt="" src={picpresent6} />
        <img alt="" src={picpresent7} />
        <img alt="" src={picpresent8} />
        <img alt="" src={picpresent9} />
        <img alt="" src={picpresent10} />
        <img alt="" src={picpresent11} />
        <img alt="" src={picpresent12} />
      </div>
    </div>
  );
}

export default CheckPresentNew;

